module.exports = __webpack_public_path__ + "img/mobile-help-6.9aa6ff35.jpg";